

import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-[#e0f1fc] shadow-sm fixed w-full top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-3">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/17a64c4d971417c460d286b46dfcd11d/1c8bfb56cc0c5d17ef6a1bd4d8197b46.png"
              alt="Company Logo"
              className="w-10 h-10 object-cover object-top"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <a href="#features" className="text-gray-800 hover:text-[#2d88ba] transition-colors cursor-pointer text-sm font-medium py-2 px-3 rounded-md hover:bg-gray-50">
              機能紹介
            </a>
            <a href="#pricing" className="text-gray-800 hover:text-[#2d88ba] transition-colors cursor-pointer text-sm font-medium py-2 px-3 rounded-md hover:bg-gray-50">
              会社概要
            </a>
            <a href="/" className="text-gray-800 hover:text-[#2d88ba] transition-colors cursor-pointer text-sm font-medium py-2 px-3 rounded-md hover:bg-gray-50 whitespace-nowrap">
              お問い合わせ
            </a>
            <button className="bg-[#00a8ea] text-white px-6 py-2.5 rounded-md hover:bg-[#0096d6] transition-colors cursor-pointer text-sm font-medium whitespace-nowrap shadow-sm">
              資料をダウンロード
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="lg:hidden cursor-pointer p-2 rounded-md hover:bg-gray-100 transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl text-gray-700`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg-hidden border-t border-gray-200 py-4">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              <a href="#features" className="text-gray-800 hover:text-[#2d88ba] block px-3 py-2 text-base font-medium transition-colors cursor-pointer">
                機能紹介
              </a>
              <a href="#pricing" className="text-gray-800 hover:text-[#2d88ba] block px-3 py-2 text-base font-medium transition-colors cursor-pointer">
                会社概要
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}

